import { motion } from 'framer-motion';

const talentRoles = [
  'SEO Specialist', 'Content Strategist', 'Growth Marketer', 'Brand Strategist',
  'Creative Director', 'Front-End Engineer', 'Back-End Engineer', 'Full-Stack Developer',
  'UX/UI Designer', 'Product Designer', 'DevOps Engineer', 'Copywriter',
  'Email Marketing Manager', 'Demand Generation Manager', 'Web Developer', 'Automation Engineer',
  'Performance Marketing Manager', 'Marketing Technologist', 'Data Engineer', 'AI Prompt Engineer',
];

const aiTools = [
  'Replit', 'Lovable', 'Cursor', 'Sora', 'Bubble', 'Webflow', 'Bolt.new', 'Zapier',
  'Botpress', 'Voiceflow', 'CustomGPT', 'Runway ML', 'Glide', 'Softr', 'DataRobot',
  'Lobe', 'Teachable Machine', 'BuildFire AI', 'Akkio', 'Obviously AI',
];

const RoleTag = ({ name }) => (
  <span className="marquee-tag mx-2">{name}</span>
);

const ToolTag = ({ name }) => (
  <span className="tool-tag mx-2">{name}</span>
);

const MarqueeTrack = ({ items, direction, TagComponent }) => {
  const doubled = [...items, ...items];
  return (
    <div className="marquee-container py-1.5">
      <div className={direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'}>
        {doubled.map((item, i) => (
          <TagComponent key={`${item}-${i}`} name={item} />
        ))}
      </div>
    </div>
  );
};

export const TalentMarquee = () => (
  <section className="py-16 md:py-20 bg-background border-t border-border overflow-hidden">
    <div className="section-container mb-10">
      <motion.p
        className="section-label mb-4"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        Access to
      </motion.p>
      <motion.h2
        className="text-[32px] sm:text-[38px] font-bold tracking-tight text-foreground"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        9,000+ Pre-Vetted Specialists
        <span className="text-muted-foreground font-medium"> powered by top AI tools</span>
      </motion.h2>
    </div>

    <div className="flex flex-col gap-4">
      <MarqueeTrack items={talentRoles} direction="left" TagComponent={RoleTag} />
      <MarqueeTrack items={aiTools} direction="right" TagComponent={ToolTag} />
    </div>
  </section>
);
